import { getIsFlexJoinPath, getIsTabJoinPath, getIsTakeawayPath } from "./url";

const LEGACY_MEANDU_TOKEN_BASE_URLS = ["https://app.meandu.com", "https://app.meandu.com.au"]; // 1.0 production URLs
const CURRENT_SITE_TOKEN_URL = window.location.origin; // Allows for localhost PWA testing
const MEANDU_WEB_TOKEN_PATTERN = /https:\/\/[\w-]+\.meandu\.com/; // Allows the native app to read any non-production PWA tags
const MEANDU_APP_VENUE_URL_PATTERN = /^https:\/\/(www\.)?meandu\.app$/;
const MEANDU_APP_QR_URL_PATTERN = /^https:\/\/qr\.meandu\.app$/;
const VENUE_STYLE_QR_PATH_PATTERN =
    /^\/([\w]+\/o\/[\d\w-]+\/)?[\d\w-]+(\/(pickup|dine-in|delivery|menu|counter|in-venue|catering|bill-pay)(\/[\d\w-]+)?)?\/?$/i;

export const SCAN_ERROR_DISMISS_DELAY = 5000;

export type QrCodeErrors = "QrCodeCameraAccessDenied" | "QrCodeUnknownError" | "FindQrCodeTimeout";

export class QrCodeError extends Error {
    constructor(public errorCode: QrCodeErrors, public additionalInfo?: string) {
        super(`QrCodeError: ${errorCode}${additionalInfo ? `: ${additionalInfo}` : ""}`);
        // TODO: Look at setting an ES6 target so we can remove this
        Object.setPrototypeOf(this, QrCodeError.prototype);
    }
}

export const validateQrCodeContents = (contents: string) => {
    try {
        const url = new URL(contents);
        const { origin, pathname } = url;
        const validOrigin =
            LEGACY_MEANDU_TOKEN_BASE_URLS.includes(origin) ||
            origin === CURRENT_SITE_TOKEN_URL ||
            MEANDU_APP_VENUE_URL_PATTERN.test(origin) ||
            MEANDU_APP_QR_URL_PATTERN.test(origin) ||
            MEANDU_WEB_TOKEN_PATTERN.test(origin);

        if (!validOrigin) return false;
        if (pathname === "/qr") return true;
        if (VENUE_STYLE_QR_PATH_PATTERN.test(pathname)) return true;

        return getIsTabJoinPath(pathname) || getIsTakeawayPath(pathname) || getIsFlexJoinPath(pathname);
    } catch (err) {
        return false;
    }
};

export const shouldRedirectQrCodeContentsToMeanduApp = (contents: string) => {
    if (!validateQrCodeContents(contents)) return false;

    const { origin } = new URL(contents);

    return MEANDU_APP_VENUE_URL_PATTERN.test(origin) || MEANDU_APP_QR_URL_PATTERN.test(origin);
};

const backCameraKeywords = [
    "rear",
    "back",
    "rück",
    "arrière",
    "trasera",
    "trás",
    "traseira",
    "posteriore",
    "后面",
    "後面",
    "背面",
    "后置", // alternative
    "後置", // alternative
    "背置", // alternative
    "задней",
    "الخلفية",
    "후",
    "arka",
    "achterzijde",
    "หลัง",
    "baksidan",
    "bagside",
    "sau",
    "bak",
    "tylny",
    "takakamera",
    "belakang",
    "אחורית",
    "πίσω",
    "spate",
    "hátsó",
    "zadní",
    "darrere",
    "zadná",
    "задня",
    "stražnja",
    "belakang",
    "बैक",
];

export const isBackCameraLabel = (label: string) =>
    label && backCameraKeywords.some((keyword) => label.toLowerCase().indexOf(keyword) !== -1);
